import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import EmployeeExpenseEditModal from '../../../../../../../../../../specificComponents/Employee/EmployeeExpenses/EmployeeExpenseEditModal'

type ModalEditEmployeeExpensesProps = ModalEditComponentProps & {}

const ModalEditEmployeeExpenses: React.FC<ModalEditEmployeeExpensesProps> = ({...rest }) => {
    return (<EmployeeExpenseEditModal {...rest} />)
}

export default ModalEditEmployeeExpenses;